import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addBalance, buySeats, upgradePlan } from '@/redux/app/actions/organization';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';
import { Link } from '@/lib/navigation/links/Link';
import { orgCheckoutSeatQuantitySelector, orgCheckoutBalanceSelector, orgCheckoutLineItemsSelector, orgCheckoutTotalTodaySelector } from '../../../redux/app/selectors/organization';
import { CheckoutSubscriptionSummary } from './CheckoutSubscriptionSummary';

interface CheckoutSummaryProps {
  checkoutType: string;
  handleProcessing: () => void;
  checkoutSummaryRef: any;
}

export const CheckoutSummary = ({
  checkoutType, handleProcessing, checkoutSummaryRef,
}: CheckoutSummaryProps) => {
  const checkoutBalance = useSelector(orgCheckoutBalanceSelector);
  const checkoutSeatQuantity = useSelector(orgCheckoutSeatQuantitySelector);
  const { subdomain } = React.useContext(NavigationPaneRouteParamsContext);
  const dispatch = useDispatch();

  const handleCheckout = () => {
    switch (checkoutType) {
      case 'addPlanUpgrade':
        dispatch(upgradePlan({ subdomain, plan: 'standard-plan-4' }));
        break;
      case 'addSeats':
        dispatch(buySeats({ subdomain, avochato_seats: checkoutSeatQuantity }));
        break;
      case 'addBalance':
        dispatch(addBalance({ subdomain, balance: checkoutBalance }));
        break;
      default:
        break;
    }
    handleProcessing();
  };
  const lineItems = useSelector(orgCheckoutLineItemsSelector);
  const totalToday = useSelector(orgCheckoutTotalTodaySelector);

  const allLineItems = Object.values(lineItems).map((li: any) => (
    <tr key={li.id}>
      <td><p className="py-10 fsz-14">{li.name}</p></td>
      <td><p className="fsz-14">{li.unitCost}</p></td>
      <td><p className="fsz-14">{li.quantity}</p></td>
      <td className="right"><p className="fsz-14">{li.total}</p></td>
    </tr>
  ));

  return (
    <div ref={checkoutSummaryRef} id="checkout-summary-container">
      <div className="checkout-summary body">
        <h2 className="mb-20">Checkout Summary</h2>
        <div className="table-wrapper">
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
                <td><p className="py-5 bold-900 gray" style={{ width: '160px' }}>Item</p></td>
                <td><p className="bold-900 gray">Unit</p></td>
                <td><p className="bold-900 gray">Qty</p></td>
                <td className="right"><p className="bold-900 gray">Total</p></td>
              </tr>
            </thead>
            <tbody>
              {allLineItems}
              <tr>
                <td><p className="py-10 bold-900 fsz-20 sea-green">Due Today:</p></td>
                <td />
                <td />
                <td className="right"><p className="bold-900 fsz-20 sea-green">{totalToday}</p></td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          type="button"
          className="button bright-green mt-20 lg"
          style={{ width: '370px', alignSelf: 'center' }}
          onClick={handleCheckout}
        >
          Purchase
        </button>
        <p className="fsz-13 mt-15 center">
          By Clicking “Purchase”, you agree to our&nbsp;
          <Link path={`${window.location.origin}/terms`}>
            <span
              className="fsz-13 link-blue"
              style={{ cursor: 'pointer' }}
            >
              Terms of Service
            </span>
          </Link>
          &nbsp;and&nbsp;
          <Link path={`${window.location.origin}/privacy`}>
            <span
              className="fsz-13 link-blue"
              style={{ cursor: 'pointer' }}
            >
              Privacy Statement
            </span>
          </Link>
          .&nbsp;We’ll occasionally send out account related emails. All amounts are shown in USD.
        </p>
      </div>
      {!lineItems.balance && <CheckoutSubscriptionSummary />}
    </div>
  );
};
